import { useState } from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import styled from "styled-components";
import Menu from './components/Menu';
import { Navbar } from './components/Navbar';
import { Message } from './components/Message';
import { Python } from './components/Python';
import { Home } from './components/Home';
import './App.css';
import { Cprogram } from './components/Cprogram';
import { Java } from './components/Java';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faDownload, faXmark } from '@fortawesome/free-solid-svg-icons'

const Container = styled.div`
  
`;
const Main = styled.div`
  flex: 1;
  padding: 15px 30px;
  background: #1b1f38;
  overflow: auto;
  box-shadow: 2px 2px 10px #1e223b;
  height: calc(100vh - 70px);
`;
const Wrapper = styled.div`
  display: flex;
`;


function App() {
    const [isToggle, setToggle] = useState(false);
    const [showFrame, setShowFrame] = useState(false);
    const [iframSrc, setIframeUrl] = useState('');
    const [progName, setProgName] = useState('Filename');
    const [downLink, setDownLink] = useState('filename.txt');
    const handleToggle = () => {
        setToggle(!isToggle);
    }

    const showProg = (name, url, download) =>{
      setShowFrame(true);
      setProgName(name);
      setIframeUrl(url);
      setDownLink(download);
    }

  return (
    <Container>
      <Router basename={"/repository"}>
        <Navbar handleToggle={handleToggle} />
        <Wrapper>
          <Menu navCollapse={isToggle} handleToggle={handleToggle}/>
          <Main>
            <Message/>
            
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/cprograms" element={<Cprogram setProgUrl={showProg} />} />
                <Route path="/java" element={<Java setProgUrl={showProg} />} />
                <Route path="/python" element={<Python setProgUrl={showProg} />} />
                <Route path="*" element={<Home />} />
              </Routes>
            
          </Main>
        </Wrapper>
      </Router>
      <div className={`code-wrapper ${showFrame? "d-block" : "d-none"}`}>
        <div className="topbar">
            <p className="topname">{progName}</p>
            <span className="w-icons"><a href={downLink} download={progName} title='Download' target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faDownload} /></a></span>
            <span className="w-icons" onClick={e=>setShowFrame(false)}><FontAwesomeIcon icon={faXmark} /></span>
        </div>
          <div className="popup">
              <iframe src={iframSrc} title='Code Viewer'>
                  <p>Your browser does not support iframes.</p>
              </iframe>
          
          </div>
      </div>
    </Container>
  );
}

export default App;
